export default __webpack_public_path__ + "static/media/woman-resting-with-phone-headphones.22a206ca.jpg";